export default __webpack_public_path__ + "static/media/errorPage.11e1cd04.png";